export const isPhoneE164 = value => !!value.match(/^\+[1-9]\d{1,14}$/);

export const isPhoneNumberValid = (value, dialCode) => {
  const number = value.replace(dialCode, '');
  return !!number.match(/^[0-9]{1,14}$/);
};

export const isPhoneE164OrEmpty = value => isPhoneE164(value) || value === '';

export const isContactPhoneValid = value =>
  !value || /^\+[1-9]\d{6,14}$/.test(value);

export const isPhoneNumberValidWithDialCode = value => {
  const number = value.replace(/^\+/, ''); // Remove the '+' sign
  return !!number.match(/^[1-9]\d{4,}$/); // Validate the phone number with minimum 5 digits
};

export const startsWithPlus = value => value.startsWith('+');

export const shouldBeUrl = (value = '') =>
  value ? value.startsWith('http') : true;
export const isPhoneIsrael = value => !!value?.match(/^(\+[1-9]|05)\d{1,14}$/);
export const isValidPhoneStart = value => {
  if (!value) return true;
  let lengthInvalid = false;
  if(value.startsWith('+972') && value.length > 13)
    lengthInvalid = true
  const startInvalid = value.startsWith('+9720');
  return !(startInvalid || lengthInvalid)
};
export const isPhoneIsraelOptional = value => {
  if (value.length === 0) {
    return true;
  }

  return isPhoneIsrael(value);
};
export const isPhoneIsraelEmpty = value =>
  isPhoneIsrael(value) || value === '' || value === null;

export const isEmailValid = value =>
  isPhoneIsrael(value) || value === '' || value === null;

export const isValidPassword = value => {
  const containsUppercase = /[A-Z]/.test(value);
  const containsLowercase = /[a-z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecialCharacter = /[!@#$%^&*()_+\-=[\]{}|'"/\\.,`<>:;?~]/.test(
    value
  );
  return (
    containsUppercase &&
    containsLowercase &&
    containsNumber &&
    containsSpecialCharacter
  );
};

export const isNumber = value => /^\d+$/.test(value);

export const isDomain = value => {
  if (value !== '') {
    const domainRegex = /^([\p{L}0-9]+(-[\p{L}0-9]+)*\.)+[a-z]{2,}$/gmu;
    return domainRegex.test(value);
  }
  return true;
};
